import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ios-unread-icon-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "ios-unread-badge ios-unread-badge--on-icon"
}
const _hoisted_3 = {
  key: 1,
  class: "header-messenger-spacer",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_ctx.authenticated)
    ? (_openBlock(), _createBlock(_component_ion_button, {
        key: 0,
        fill: "clear",
        class: "header-messenger-btn",
        "aria-label": "Liga.Chat",
        onClick: _ctx.openMessenger
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_component_ion_icon, {
              icon: _ctx.chatbubbleEllipsesOutline,
              slot: "icon-only"
            }, null, 8, ["icon"]),
            (_ctx.unreadLabel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.unreadLabel), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onClick"]))
    : (_openBlock(), _createElementBlock("span", _hoisted_3))
}